import { render, staticRenderFns } from "./shipProgress-add-or-update.vue?vue&type=template&id=22d363f2&scoped=true"
import script from "./shipProgress-add-or-update.vue?vue&type=script&lang=js"
export * from "./shipProgress-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./shipProgress-add-or-update.vue?vue&type=style&index=0&id=22d363f2&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d363f2",
  null
  
)

export default component.exports